<template>
  <div>
    <v-btn color="primary" @click="dialogExcel = true">Import Excel</v-btn>

    <v-dialog v-model="dialogExcel" persistent max-width="500px" transition="dialog-transition">
      <v-card>
        <v-card-title>Import Excel</v-card-title>
        <v-card-text>
          <v-container>
            <center>
              <v-btn color="secondary" @click="$refs.inputFile.click()">Pilih File</v-btn>
              <p class="mt-5 mb-0">{{ fileName }}</p>

              <input type="file" ref="inputFile" @change="onChangeUpload" style="display: none;" />
            </center>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="error" text @click="dialogExcel = false">Batal</v-btn>
          <v-btn color="primary" text @click="uploadExcel">Upload</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ImportExcel",
  data: () => ({
    dialogExcel: false,
    fileExcel: "",
    fileName: "",
    fileError: ""
  }),
  methods: {
    onChangeUpload(e) {
      const fileExcel = e.target.files[0];

      this.fileExcel = fileExcel;
      this.fileName = fileExcel.name;
    },
    validateFile() {
      this.fileError = "";

      if (this.fileExcel) {
        const extension = this.fileName.split(".").pop();

        const standartExtensions = ["xls", "xlsx", "csv"];
        const isRight = standartExtensions.filter(
          ex => ex === extension.toLowerCase()
        );

        if (isRight.length === 0)
          this.fileError = "Format file harus berupa .xls / .xlsx / .csv";
      } else this.fileError = "File wajib diisi";
    },
    async uploadExcel() {
      this.validateFile();
      if (this.fileError) return;

      const url = this.$api.replace("/api/v1", "");
      await axios.post(`${url}/exports`, {
        act: "hasil-seleksi",
        export: "excel",
        resultExam: this.fileExcel
      });

      this.dialogExcel = false;
    }
  }
};
</script>